(() => {
  if (customElements.get('dashea-footer')) return;
  class DasheaFooter extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      // A previously registered custom element can connect before the HTML
      // parser has finished its children (also possible in theme previews).
      if (!this.querySelector('[data-footer-ready]')) {
        if (!this.pending) {
          this.pending = new MutationObserver(() => {
            if (this.isConnected && this.querySelector('[data-footer-ready]')) this.connectedCallback();
          });
          this.pending.observe(this, { childList: true, subtree: true });
        }
        return;
      }
      this.pending?.disconnect();
      this.pending = null;
      this.abort = new AbortController();
      const { signal } = this.abort;
      this.mobile = matchMedia('(max-width: 800px)');
      this.menus = [...this.querySelectorAll('.dh-footer__menu')];
      this.mobileOpen = new Map();
      this.syncMenus = () => this.menus.forEach(menu => {
        menu.open = this.mobile.matches ? (this.mobileOpen.get(menu) || false) : true;
        const summary = menu.querySelector('summary');
        summary.tabIndex = this.mobile.matches ? 0 : -1;
        if (this.mobile.matches) summary.removeAttribute('aria-disabled');
        else summary.setAttribute('aria-disabled', 'true');
      });
      this.menus.forEach(menu => {
        menu.querySelector('summary').addEventListener('click', event => {
          if (!this.mobile.matches) event.preventDefault();
          else this.mobileOpen.set(menu, !menu.open);
        }, { signal });
      });
      this.mobile.addEventListener('change', this.syncMenus, { signal });
      this.syncMenus();
      this.inViewport = false;
      const syncVisibility = () => { this.dataset.inView = String(this.inViewport && !document.hidden); };
      this.observer = new IntersectionObserver(entries => {
        this.inViewport = entries[0].isIntersecting;
        syncVisibility();
      }, { threshold: 0 });
      this.observer.observe(this.querySelector('.dh-footer__signature'));
      document.addEventListener('visibilitychange', syncVisibility, { signal });
      // Local preview is intentionally non-mutating, including the market forms.
      // Production retains Shopify's native newsletter/localization submit path.
      const preview = ['127.0.0.1', 'localhost', '[::1]'].includes(location.hostname) && window.DASHEA_PREVIEW?.enabled === true;
      if (preview) this.querySelectorAll('form').forEach(form => {
        form.addEventListener('submit', event => {
          event.preventDefault();
          let status = form.previewStatus;
          if (!status) {
            status = document.createElement('p');
            status.dataset.footerPreviewStatus = '';
            status.className = 'dh-footer__form-message';
            status.setAttribute('role', 'status');
            status.tabIndex = -1;
            form.after(status);
            form.previewStatus = status;
          }
          status.textContent = form.classList.contains('dh-footer__newsletter')
            ? 'Lokální náhled: e-mail se nikam neodeslal. Odběr ověříme při nasazení.'
            : 'Lokální náhled: jazyk ani trh obchodu jsme nezměnili.';
          status.focus();
        }, { signal });
      });
    }
    disconnectedCallback() {
      this.pending?.disconnect();
      this.pending = null;
      this.abort?.abort();
      this.abort = null;
      this.observer?.disconnect();
    }
  }
  customElements.define('dashea-footer', DasheaFooter);
})();
